




















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ImagePreview from '../image/image-preview.vue';

@Component({
  name: 'ComponentItem',
  components: { ImagePreview }
})
export default class ComponentItem extends Vue {
  itActive = -1;
  itActiveList: number[] = [];
  @Prop({ default: null, type: [Array, String, Object] })
  item: any;

  isString(val: string) {
    return typeof val === 'string';
  }
  get isActive() {
    return true;
  }
  isArray(val: any) {
    return Array.isArray(val);
  }
  isObject(val: any) {
    const type = typeof val;
    return val != null && (type === 'object' || type === 'function');
  }

  // beforeCreate() {
  //   // console.log('0-----===>',import('../component-item.vue'))
  // //  setTimeout(()=>{
  // //     import('../component-item.vue').then(()=>{})
  // //  })
  //   // this.$options.components.ComponentItem = require('../component-item.vue').default;

  // }

  getStyleByType(item: any, isLi = false) {
    if (item == null || this.isString(item)) {
      return;
    }
    let style = {};
    const { color, backgroundColor, height } = item;
    if (isLi === false) {
      if (color) {
        style = { ...style, color };
      }
      if (backgroundColor) {
        style = { ...style, 'background-color': backgroundColor };
      }
    } else {
      if (height) {
        style = { ...style, height };
      }
    }
    return style;
  }
  getClassByType(item: any) {
    if (item == null || this.isString(item)) {
      return { 'lower-latin': true };
    }
    const { type, color, backgroundColor } = item;
    let dClass: any = { none: true };
    switch (type) {
      case 'option':
        dClass = { option: true };
        break;
      case 'abc':
        dClass = { 'lower-latin': true };
        break;
      case '123)':
        dClass = { 'decimal-parenthesis': true };
        break;
      case 'dot':
        dClass = { dot: true };
        break;
      case 'p':
        dClass = { p: true };
        break;
      case 'span':
        dClass = { span: true };
        break;
      case 'image':
        dClass = { image: true };
        break;
      case 'br':
        dClass = {};
        break;
      default:
        break;
    }
    return dClass;
  }
  toggle(idx: number) {
    this.itActive = idx === this.itActive ? -1 : idx;
    const ix = this.itActiveList.indexOf(idx);
    if (~ix) {
      this.itActiveList.splice(idx, 1);
    } else {
      this.itActiveList.push(idx);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collapse/component-item.vue